import axios from 'axios';
import _ from 'lodash';
import qs from 'query-string';
import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';
import ProfiloService from './profilo';
import ContrattoService from './contratto';

const create = (content) => request(
  {
    url: API.COLLABORATORE,
    method: 'POST',
    data: content,
  });

const put = (content) => request(
  {
    url: `${API.COLLABORATORE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const getById = (id) => request(
  {
    url: `${API.COLLABORATORE}/${id}`,
    method: 'GET',
  });

const getAll = (pageSize) => request(
  {
    url: API.COLLABORATORE,
    method: 'GET',
    params: {
      page_size: pageSize || 10000,
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getAllOptions = () => getAll(0).then(
  (res) => {  // TODO: Idratare risposta con anagrafica e/o nominativo
    const messyData = res._embedded.collaboratore.map((obj)=>{ return {value: obj.id, label: _.get(obj,'_embdedded.anagrafica.nominativo') || '' /*obj._embedded.anagrafica.nominativo*/ }}) // eslint-disable-line
    return _.orderBy(messyData, 'label', 'asc');
  }).then((data) => ({ options: data }));

const getWithProfiliAndContratti = (id) =>
  axios.all([getById(id), ProfiloService.getProfiliByCollaboratore(id), ContrattoService.getContrattiByCollaboratore(id)])
  .then(axios.spread((collaboratore, profili, contratti) => {
    const collaboratoreObj = Object.assign({}, collaboratore);
    const profiliObj = Object.assign({}, profili);
    const contrattiObj = Object.assign({}, contratti);

    collaboratoreObj.profili = profiliObj._embedded.profilocollaboratore; //eslint-disable-line
    collaboratoreObj.contratti = contrattiObj._embedded.contrattocollaboratore; //eslint-disable-line
    return collaboratoreObj;
  }));


const CollaboratoreService = {
  create,
  getById,
  getWithProfiliAndContratti,
  put,
  getAll,
  getAllOptions,
};

export default CollaboratoreService;



// WEBPACK FOOTER //
// ./app/shared/services/api/collaboratore/index.js